import React from "react";

import estiloA from "./styles/TarjetasVideoA.module.css";
import estiloB from "./styles/TarjetasVideoB.module.css";

import Foto from "./Foto";

import { tiempoTranscurrido } from "../utils/tiempo";

function TarjetasVideo({ e, variante }) {
  const fechaActual = new Date();

  const estilo = variante === "inicio" ? estiloA : estiloB;

  return (
    <div className={estilo.tarjetas_video}>
      <Foto usuario={e.usuario} tiempo={e.tiempo} variante={variante}></Foto>

      <div className={estilo.informacion}>
        <div className={estilo.foto_perfil}>
          <svg width="74" height="74" viewBox="0 0 24 24">
            <path d="M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm0 5c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3zm-5.106 9.772c.897-1.32 2.393-2.2 4.106-2.2h2c1.714 0 3.209.88 4.106 2.2C15.828 18.14 14.015 19 12 19s-3.828-.86-5.106-2.228z"></path>
          </svg>
        </div>

        <div className={estilo.datos}>
          <h4>{e.nombre}</h4>
          <p>{e.usuario}</p>
          <div className={estilo.datos_cantidad}>
            <p>{e.visualizaciones} vistas</p>
            <p>{tiempoTranscurrido(e.created_at, fechaActual)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TarjetasVideo;
